import { UserAttributesClient } from 'frontend-preferences-client';
export const USER_ATTRIBUTE_HIDE_LEAD_FOLLOW_UP_TASKS = 'Tasks:Leads:FollowUpTasks:hide';
export const fetchLeadFollowUpHiddenSettings = (__unusedKey, httpClient) => {
  return UserAttributesClient.forCaller('customer-data-properties').withHttpClient(httpClient).fetch(USER_ATTRIBUTE_HIDE_LEAD_FOLLOW_UP_TASKS, 'false').then(value => {
    return value === 'true';
  });
};